import { api } from "./api";

export const getTopics = () => api.get("/topics");

export const getTopicMessages = (topicId) => api.get(`/topics/${topicId}`);
